import React from 'react';
import classNames from 'classnames';

const InspectionsFooter = (props) => {
    const count = (props.page * 10) + props.inspections.length;

    return (
	<div className="row bg-white pb20 pt20">
        <div className="col-xs-2 text-left">
            <button
                className={classNames('btn btn-outline-secondary w100p', { hidden: (props.page === 0) })}
                onClick={props.changePageBack}
            >
                Anterior
            </button>
        </div>
        <div className="col-xs-8 text-center text-md pt20">
            {props.inspections.length ? <span>{ (props.page * 10) + 1} al { (props.page * 10) + props.inspections.length} de {props.total}</span> : ''}
        </div>
        <div className="col-xs-2 text-right">
            {
                ((props.statusService === 2 && props.inspections.length) && (count < props.total))
                ?
                <button
                    className={classNames('btn btn-outline-secondary w100p', { hidden: (props.page >= props.pages - 1) })}
                    onClick={props.changePageNext}
                >
                    Siguiente
                </button>
                :
                null
            }
        </div>
    </div>
    )
};
export default InspectionsFooter;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspections/inspections-footer.js